export const customSelect = {
	option: (provided: any) => ({
		...provided,

		width: "100%",
		height: "2.5rem",

		backgroundColor: "#fff",

		fontSize: "1rem",
		color: "#000",

		padding: "0.5rem",

		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",

		borderStyle: "solid",
		borderWidth: "0 1px 1px 1px",
		borderColor: "#62606F",
		// borderRight: "1px solid #c0c4df",

		"&:hover": {
			backgroundColor: "#2d7bbc",

			color: "#fff",
		},

		"&:first-child": {
			borderTop: "1px solid #62606F",

			borderRadius: "0.25rem 0.25rem 0 0",
		},

		"&:last-child": {
			// borderBottom: "1px solid #c0c4df",

			borderRadius: "0 0 0.25rem 0.25rem",
		},
	}),
	control: (provided: any, state: any) => ({
		...provided,

		height: "3rem",
		width: "100%",

		borderColor: " #c0c4df",

		overflow: "auto",

		"&:hover": {
			borderColor: "#c0c4df",
		},
	}),
	container: (provided: any) => ({
		...provided,

		display: "flex",

		justifyContent: "center",
	}),
	menu: (provided: any) => ({
		...provided,

		width: "100%",

		background: "none",

		boxShadow: "none",

		marginTop: "4px",

		overflowY: "auto",
		overflowX: "hidden",
	}),
	menuList: (provided: any) => ({
		...provided,

		overflowY: "auto",
		overflowX: "hidden",

		padding: "0",

		maxHeight: "10.5rem",

		paddingRight: "0.25rem",

		margin: "0",
	}),

	placeholder: (provided: any, state: any) => ({
		...provided,

		fontFamily: "Roboto",
		fontWeight: "300",
		fontSize: "1.2rem",

		lineHeight: "28px",

		color: state.isFocused ? "#2d7bbc" : "#c0c4df",
	}),
	singleValue: (provided: any) => ({
		...provided,

		fontSize: "1.3rem",
		fontFamily: "Mulish",
		color: "black",
	}),
	valueContainer: (provided: any, state: any) => ({
		...provided,

		paddingLeft: "0.25rem",

		color: state.isFocused ? "#2d7bbc" : "black",
	}),
};


export const customListSelect = {
	option: (provided: any) => ({
		...provided,

		width: "100%",
		height: "2.5rem",

		backgroundColor: "#fff",

		fontSize: "1rem",
		color: "#000",

		padding: "0.5rem",

		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",

		borderStyle: "solid",
		borderWidth: "0 1px 1px 1px",
		borderColor: "#62606F",
		// borderRight: "1px solid #c0c4df",

		"&:hover": {
			backgroundColor: "#2d7bbc",

			color: "#fff",
		},

		"&:first-child": {
			borderTop: "1px solid #62606F",

			borderRadius: "0.25rem 0.25rem 0 0",
		},

		"&:last-child": {
			// borderBottom: "1px solid #c0c4df",

			borderRadius: "0 0 0.25rem 0.25rem",
		},
	}),
	control: (provided: any, state: any) => ({
		...provided,

		height: "6rem",
		width: "100%",

		borderColor: " #c0c4df",

		overflow: "auto",

		"&:hover": {
			borderColor: "#c0c4df",
		},
	}),
	container: (provided: any) => ({
		...provided,

		display: "flex",

		justifyContent: "center",
	}),
	menu: (provided: any) => ({
		...provided,

		width: "100%",

		background: "none",

		boxShadow: "none",

		marginTop: "4px",

		overflowY: "auto",
		overflowX: "hidden",
	}),
	menuList: (provided: any) => ({
		...provided,

		overflowY: "auto",
		overflowX: "hidden",

		padding: "0",

		maxHeight: "10.5rem",

		paddingRight: "0.25rem",

		margin: "0",
	}),

	placeholder: (provided: any, state: any) => ({
		...provided,

		fontFamily: "Roboto",
		fontWeight: "300",
		fontSize: "1.2rem",

		lineHeight: "28px",

		color: state.isFocused ? "#2d7bbc" : "#c0c4df",
	}),
	singleValue: (provided: any) => ({
		...provided,

		fontSize: "1.3rem",
		fontFamily: "Mulish",
		color: "black",
	}),
	valueContainer: (provided: any, state: any) => ({
		...provided,

		paddingLeft: "0.25rem",

		color: state.isFocused ? "#2d7bbc" : "black",
	}),
};
